var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#F15A24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.8,342.6c-28.8,0-52.2-23.4-52.2-52.2V78c0-28.8,23.4-52.2,52.2-52.2S161,49.1,161,78v212.5 C161,319.3,137.6,342.6,108.8,342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.7,487c-106.9,0-193.8-87-193.8-193.8s87-193.8,193.8-193.8s193.8,87,193.8,193.8S357.5,487,250.7,487z  M250.7,203.7c-49.3,0-89.5,40.1-89.5,89.5s40.1,89.5,89.5,89.5s89.5-40.1,89.5-89.5S300,203.7,250.7,203.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 392.1,
    cy: 431.8,
    r: 52.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo-icon-white.2e68c6c125aaee1543dd604f66853ada.svg";
export { ForwardRef as ReactComponent };